import { format } from 'date-fns';
import { DATE_DD_MON_YEAR_HH_MM } from 'constants/dateFormat';

export type GetDateFormattedOptions = {
  date?: string;
  formatString?: string;
};

export const getDateFormatted = ({
  date,
  formatString = DATE_DD_MON_YEAR_HH_MM,
}: GetDateFormattedOptions): string => {
  if (!date) {
    return format(new Date(), formatString);
  }

  return format(new Date(date), formatString);
};
